export const ADD_EXPECTED_VESSEL = 'add expected vessel';
export const ADD_EXPECTED_VESSEL_SUCCESS = 'add expected vessel success';
export const ADD_EXPECTED_VESSEL_FAILURE = 'add expected vessel failure';

export const REMOVE_EXPECTED_VESSEL_BY_ID = 'remove expected vessel';
export const REMOVE_EXPECTED_VESSEL_BY_ID_SUCCESS = 'remove expected vessel success';
export const REMOVE_EXPECTED_VESSEL_BY_ID_FAILURE = 'remove expected vessel failure';

export const addExpectedVessel = (data) => ({
  type: ADD_EXPECTED_VESSEL,
  payload: data
});

export const removeExpectedVesselById = (data) => ({
  type: REMOVE_EXPECTED_VESSEL_BY_ID,
  payload: data
});

